import { Space, Button } from 'antd';
import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import DrawerWithAutoWidth from '../../../../components/DrawerWithAutoWidth';
import AddTtbPaymentSettingsForm from './AddTtbPaymentSettingsForm';

export type TtbPaymentSettingsDrawerProps = {
    onClose: () => void;
    visible: boolean;
    moduleId: string;
};

const TtbPaymentSettingsDrawer = ({ onClose, visible, moduleId }: TtbPaymentSettingsDrawerProps) => {
    const { t } = useTranslation(['ttbPaymentModuleDetails']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>{t('ttbPaymentModuleDetails:paymentSettingsDrawer.cancelButton')}</Button>
                    <Button form="addFiservPaymentSettings" htmlType="submit" type="primary">
                        {t('ttbPaymentModuleDetails:paymentSettingsDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('ttbPaymentModuleDetails:paymentSettingsDrawer.title.create')}
            visible={visible}
            destroyOnClose
        >
            <AddTtbPaymentSettingsForm moduleId={moduleId} onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default TtbPaymentSettingsDrawer;

export const useTtbPaymentSettingsDrawer = (moduleId: string) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => <TtbPaymentSettingsDrawer moduleId={moduleId} onClose={actions.close} visible={visible} />,
    };
};
